import React, { lazy } from 'react';
import { motion } from 'framer-motion';
export function WhatsIncluded() {
  return <section className="py-10 md:py-20 px-5 md:px-6 bg-white" data-id="element-192">
      <div className="max-w-4xl mx-auto" data-id="element-193">
        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="rounded-3xl overflow-hidden shadow-xl border border-[#F9A8B7]/20" data-id="element-194">
          <img src="https://cdn.magicpatterns.com/uploads/cX3BKsvUPoKdprYuRZid5W/landing_3_mockup.png" alt="Compra hoy y recibirás: 500 recetas para introducción alimentaria, recetario semanal con lista de compras, y guía completa de introducción alimentaria" loading="lazy" className="w-full h-auto block" data-id="element-195" />
        </motion.div>
      </div>
    </section>;
}